/**
 * Pagination component with ellipsis logic.
 * Displays "Prev", "Next" and dynamic page numbers.
 *
 * @component
 * @param {Object} props
 * @param {number} props.currentPage - Currently active page
 * @param {number} props.totalPages - Total number of pages
 * @param {(page: number) => void} props.onPageChange - Handler for page change
 */
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pages = [];

  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 ||
      i === totalPages ||
      (i >= currentPage - 1 && i <= currentPage + 1)
    ) {
      pages.push(i);
    } else if (
      (i === currentPage - 2 && i > 2) ||
      (i === currentPage + 2 && i < totalPages - 1)
    ) {
      pages.push("...");
    }
  }

  return (
    <div className="flex justify-center items-center gap-2 flex-wrap mt-4 text-sm">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 border rounded disabled:opacity-50">
        Prev
      </button>

      {pages.map((page, index) =>
        page === "..." ? (
          <span key={index} className="px-2 text-gray-400">
            ...
          </span>
        ) : (
          <button
            key={index}
            onClick={() => onPageChange(page)}
            className={`px-3 py-1 rounded ${
              currentPage === page
                ? "bg-blue-500 text-white"
                : "border hover:bg-gray-100"
            }`}>
            {page}
          </button>
        )
      )}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 border rounded disabled:opacity-50">
        Next
      </button>
    </div>
  );
};

export default Pagination;
